/**
 * Enumeration representing different severity levels for PrimeNG Toast messages.
 *
 * @see https://primeng.org/toast#severity
 */
export enum PrimeNGToastSeverity {
    SUCCESS = 'success',
    INFO = 'info',
    WARN = 'warn',
    ERROR = 'error',
}
